import React from 'react';
import KickImage from 'Reuseables/KickImage';

const SneakerLoadingSpinner = props => {
  const loadingTextCSS = {
    visibility: props.isLoading ? 'visible' : 'hidden',
    // display: 'block',
    height: props.wrapperHeight,
    width: props.wrapperWidth
  };
  const loadingCSS = {
    textAlign: 'center',
    height: props.height,
    margin: '30px auto',
    marginTop: !props.isLoading || props.isHide ? '-150px' : '30px',
    zIndex: -1,
    position: 'relative'
  };
  return (
    <div
      ref={props.wrapperRef}
      style={loadingCSS}
    >
      <KickImage style={loadingTextCSS} src="/images/loader.gif" alt="Loading..."/>
    </div>
  )
}

SneakerLoadingSpinner.defaultProps = {
  isLoading: false,
  isHide: true,
  wrapperHeight: 150,
  wrapperWidth: 150,
  height: 150
}

export default SneakerLoadingSpinner;